import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar", "text", "passwordField"];

  connect() {
    if (this.hasPasswordFieldTarget) {
      this.passwordFieldTarget.addEventListener("input", this.check.bind(this));
    }

    if(this.hasBarTarget) {
      this.createBorders();
    }
    // Fetch localized strength messages
    this.messages = JSON.parse(document.getElementById('password-strength-messages').dataset.messages);
  }

  check(event) {
    const password = event.target.value;
    const strength = this.calculateStrength(password);

    this.updateStrengthBar(strength);
    this.updateStrengthText(strength);
  }

  calculateStrength(password) {
    let strength = 0;

    if (password.match(/[a-z].*[a-z].*[a-z]/)) strength++; // At least 3 lowercase letters
    if (password.match(/[A-Z].*[A-Z]/)) strength++; // At least 2 uppercase letters
    if (password.match(/\d/)) strength++; // At least one digit
    if (password.match(/[\#\?\!\@\$\%\^\&\*\-]/)) strength++; // At least one special character
    if (password.length >= 12) strength++; // Minimum length

    return strength;
  }

  updateStrengthBar(strength) {
    const widths = ["0%", "20%", "40%", "60%", "80%", "100%"];
    const gradients = [
      "bg-linear-to-r from-red-500 to-orange-500", // Very Weak
      "bg-linear-to-r from-orange-500 to-yellow-500", // Weak
      "bg-linear-to-r from-yellow-500 to-blue-400", // Moderate
      "bg-linear-to-r from-blue-500 to-green-400", // Strong
      "bg-linear-to-r from-green-500 to-emerald-500", // Very Strong
    ];

    this.barTarget.style.width = widths[strength];
    this.barTarget.className = `h-2 rounded-full transition-all duration-700 ${gradients[strength - 1] || ""}`;
    this.barTarget.style.boxShadow = `0 0 8px ${this.getGlowColor(strength)}`;
  }

  updateStrengthText(strength) {
    const colors = ["text-red-600", "text-orange-600", "text-yellow-600", "text-blue-600", "text-green-600"];

    this.textTarget.textContent = this.messages[strength - 1] || "";
    this.textTarget.className = `mt-2 text-sm font-medium transition-all ${colors[strength - 1] || ""}`;
  }

  createBorders() {
    const container = this.barTarget.parentElement;
    container.classList.add("relative", "bg-gray-200", "rounded-full", "mt-3", "overflow-hidden");

    for (let i = 0; i < 4; i++) {
      const border = document.createElement("div");
      border.classList.add("absolute", "top-0", "bottom-0", "w-px", "bg-gray-300");
      border.style.left = `${(i + 1) * 20}%`;
      container.appendChild(border);
    }
  }

  getGlowColor(strength) {
    const colors = [
      "rgba(239, 68, 68, 0.5)", // Red
      "rgba(249, 115, 22, 0.5)", // Orange
      "rgba(234, 179, 8, 0.5)", // Yellow
      "rgba(59, 130, 246, 0.5)", // Blue
      "rgba(16, 185, 129, 0.5)", // Green
    ];
    return colors[strength - 1] || "transparent";
  }

  toggleVisibility(event) {
    const passwordField = event.currentTarget.closest(".relative").querySelector("input[type='password'], input[type='text']");
    passwordField.type = passwordField.type === "password" ? "text" : "password";
  }
}
